import { ref, nextTick } from 'vue';

const blinkingId = ref('');

export function useBlinking() {
  const startBlinking = async (id: string, duration = 2000) => {
    await nextTick();
    blinkingId.value = id;

    setTimeout(() => {
      blinkingId.value = '';
    }, duration);
  };

  const isBlinking = (id: string) => blinkingId.value === id;

  return {
    blinkingId,
    startBlinking,
    isBlinking,
  };
}
